export enum ObjectTypes {
  GOAL = 'GOAL',
  ACCOUNT = 'ACCOUNT',
}

export enum WorkflowActions {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}
